exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".button___hSZmd {\n  outline: none;\n  cursor: pointer;\n  border-radius: 4px;\n  border: 0;\n  background-color: rgba(40, 167, 69, 0.7);\n  width: 100%;\n  height: 36px;\n  font-size: 18px;\n  color: #f1f1f1; }\n", "", {"version":3,"sources":["/Users/joao/Sites/workout-logger/src/components/Button/Button.sass"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe,EAAE","file":"Button.sass","sourcesContent":[".button {\n  outline: none;\n  cursor: pointer;\n  border-radius: 4px;\n  border: 0;\n  background-color: rgba(40, 167, 69, 0.7);\n  width: 100%;\n  height: 36px;\n  font-size: 18px;\n  color: #f1f1f1; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"button": "button___hSZmd"
};